import { t } from "i18next";

export const tabHeader = (title: string, usedItems?: number) => {
  let header = t(title);
  if (usedItems && usedItems > 0) header = `${header} (${usedItems})`;
  return header;
};
